import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Camera, Image as ImageIcon, Wand2, Download, Smartphone, HeartHandshake } from 'lucide-react';
export const Features = () => {
  const features = [{
    icon: <Camera className="w-6 h-6 text-white" data-id="element-8" />,
    title: 'Real-time camera',
    desc: 'High quality webcam capture directly in your browser.'
  }, {
    icon: <ImageIcon className="w-6 h-6 text-white" data-id="element-9" />,
    title: 'Polaroid style frames',
    desc: 'Cute aesthetic frames to wrap your precious memories.'
  }, {
    icon: <Wand2 className="w-6 h-6 text-white" data-id="element-10" />,
    title: 'Cute filters',
    desc: 'Soft, pinkish, and kawaii filters to enhance your look.'
  }, {
    icon: <Download className="w-6 h-6 text-white" data-id="element-11" />,
    title: 'Download instantly',
    desc: 'Save your photostrips directly to your device.'
  }, {
    icon: <Smartphone className="w-6 h-6 text-white" data-id="element-12" />,
    title: 'Mobile friendly',
    desc: 'Works perfectly on your phone, tablet, or desktop.'
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-white" data-id="element-13" />,
    title: 'Free forever',
    desc: 'No subscriptions, no watermarks, completely free.'
  }];
  return <section id="features" className="py-20 px-4 relative" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-4xl font-bold text-pink-900 mb-4" data-id="element-17">
            Why You'll Love It 💕
          </h2>
          <p className="text-pink-700 font-quicksand text-lg" data-id="element-18">
            Everything you need for the perfect aesthetic photobooth experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-19">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="glass-card p-8 rounded-3xl transition-all duration-300 hover:shadow-[0_15px_30px_rgba(255,182,193,0.4)]" data-id="element-20">
              <div className="w-14 h-14 rounded-full bg-gradient-pink flex items-center justify-center mb-6 shadow-lg shadow-pink-300/50" data-id="element-21">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-pink-900 mb-3" data-id="element-22">
                {feature.title}
              </h3>
              <p className="text-pink-700 font-quicksand" data-id="element-23">{feature.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};